module.exports = __webpack_public_path__ + "static/img/load.482a7da.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/load.gif
// module id = Am/0
// module chunks = 256